var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0024 0.571289C11.4644 0.571289 10.9477 0.784628 10.5667 1.16454L0.353426 11.3778C-0.115204 11.8464 -0.115204 12.6062 0.353425 13.0749C0.587865 13.3093 0.895174 13.4265 1.20244 13.4263C1.50971 13.4265 1.81702 13.3093 2.05146 13.0749L12.0024 3.12388L21.9534 13.0749C22.1879 13.3093 22.4952 13.4265 22.8024 13.4263C23.1097 13.4265 23.417 13.3093 23.6515 13.0749C24.1201 12.6062 24.1201 11.8464 23.6515 11.3778L13.4382 1.16454C13.0571 0.784629 12.5405 0.571289 12.0024 0.571289Z","fill":"currentColor"}));
}

ArrowUp.defaultProps = {"viewBox":"0 0 25 14","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
